/* eslint-disable no-useless-escape */
import React, { useEffect, useState } from "react";
import { ReactComponent as ThreeDot } from "../../../../../assets/MainPage/viewBlocks/ThreeDotIon.svg";
import { ReactComponent as TrashIcon } from "../../../../../assets/dashboard/link/trashIcon.svg";
import { ReactComponent as TrashIconDark } from "../../../../../assets/dashboard/link/trashIcon-dark.svg";
import { useStateContext } from "../../../../../contexts/ThemeContext";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ReactComponent as EmailIcon } from "../../../../../assets/MainPage/Socials/email.svg";
import { ReactComponent as CallIcon } from "../../../../../assets/MainPage/Socials/call.svg";
import { ReactComponent as FaceBookIcon } from "../../../../../assets/MainPage/Socials/faceBookIcon.svg";
import { ReactComponent as InstaIcon } from "../../../../../assets/MainPage/Socials/instaIcon.svg";
import { ReactComponent as Twitter } from "../../../../../assets/MainPage/Socials/twitter.svg";
import { ReactComponent as Messenger } from "../../../../../assets/MainPage/Socials/messanger.svg";
import { ReactComponent as MessengerWhite } from "../../../../../assets/MainPage/Socials/messangerWhiteIcon.svg";
import { ReactComponent as SnapIcon } from "../../../../../assets/MainPage/Socials/snapIcon.svg";
import { ReactComponent as YoutubeIcon } from "../../../../../assets/MainPage/Socials/youtube.svg";
import { ReactComponent as YoutubeIconWhite } from "../../../../../assets/dashboard/svgIcons/Youtube.svg";
import { ReactComponent as TikTok } from "../../../../../assets/MainPage/Socials/tiktok.svg";
import { ReactComponent as TikTokWhite } from "../../../../../assets/dashboard/svgIcons/tiktok.svg";
import { ReactComponent as LinkedIn } from "../../../../../assets/MainPage/Socials/linkedIn.svg";
import { ReactComponent as Spotify } from "../../../../../assets/MainPage/Socials/spotify.svg";
import { ReactComponent as Pinterest } from "../../../../../assets/MainPage/Socials/pinterest.svg";
import { ReactComponent as SoundCloud } from "../../../../../assets/MainPage/Socials/soundCloud.svg";
import { ReactComponent as Twitch } from "../../../../../assets/MainPage/Socials/twitch.svg";
import { RiCloseCircleFill } from "react-icons/ri";

import { toast } from "react-hot-toast";
import { ReactComponent as LeftArrow } from "../../../../../assets/arrow-left.svg";
import { ReactComponent as LeftArrowDark } from "../../../../../assets/arrow-left-dark.svg";
import { ReactComponent as DownArrow } from "../../../../../assets/settingPage/arrow-down.svg";

// redux
import { useDispatch, useSelector } from "react-redux";
import {
  creatingSocialBlock,
  resetUser,
} from "../../../../../redux/slices/block/createSocialBlock";
import { gettingLinkList } from "../../../../../redux/slices/gettingLinksList/gettingLinkListSlice";
import {
  updatingSocialCard,
  resetSocialCard,
} from "../../../../../redux/slices/cards/cardSlice";

import {
  deleteBlock,
  resetDeletBlock,
} from "../../../../../redux/slices/block/deleteBlockSlice";

import useFetchBlock from "../../../../../hooks/useFetchBlock";

import ConfirmModal from "../../../../../components/dashboard/modal/Confirm";
import ExtraSmallFilledButton from "../../../../../components/common/buttons/ExtraSmallFilledButton";
import useLocales from "../../../../../hooks/useLocales";
import useSettings from "../../../../../hooks/useSettings";

import { PhoneNumberUtil } from "google-libphonenumber";

import SpinnerGiff from "../../../../../assets/spinner.svg";
import { I18nextProvider } from "react-i18next";
import i18nForComponent from "../../../../../locales/component/i18nForComponent";

const phoneUtil = PhoneNumberUtil.getInstance();
const isPhoneValid = (phone) => {
  try {
    return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
  } catch (error) {
    return "Enter valid number";
  }
};

const MainCard = (prop) => {
  const { darkMode } = useSelector((state) => state.theme);

  return (
    <div
      className={`rounded-[10px] ${
        darkMode ? "" : "shadow-box_shadow_1"
      } cursor-pointer bg-light_bg_v5 dark:bg-dark-secondary p-2 pr-[13px] flex items-center gap-2`}
    >
      <div className="p-[4px]">
        <div
          style={{
            boxShadow:
              prop.boxShadow !== "" ? `-2px 3px 7px ${prop.boxShadow}` : "",
          }}
          className={`p-[7px] rounded-lg ${prop.iconBg}`}
        >
          <prop.icon className={prop.classes} />
        </div>
      </div>
      <div
        className={`text-small2 lg:text-small1 text-heading_color dark:text-color_v1_dark ${prop.titleClasses}`}
      >
        {prop.title}
      </div>
    </div>
  );
};

const LEditRExpandIconCard = ({
  setInputData,
  item,
  removeSelectedSocials,
  inputPlacholder,
}) => {
  const [input, setInput] = useState(item?.value || "");
  const [inputError, setInputError] = useState(null);
  const { darkMode } = useSelector((state) => state.theme);

  const changeHandler = (e) => {
    if (item?.key === "email") {
      let regEmail =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!regEmail.test(e.target.value)) {
        setInputError("Invalid Email");
        setInput(e.target.value);
        return false;
      } else {
        setInputError(null);
        setInput(e.target.value);
      }
    } else if (item?.key === "phone") {
      if (isPhoneValid(e.target.value)) {
        setInputError(null);
        setInput(e.target.value);
        return true;
      } else {
        setInputError("Not a valid Phone Number");
        setInput(e.target.value);
        return false;
      }
    } else if (item?.key === "facebook") {
      const facebookUsernameRegex = /^[a-zA-Z0-9.]{1,}$/;
      if (facebookUsernameRegex.test(e.target.value)) {
        setInputError(null);
        setInput(e.target.value);
        return true;
      } else {
        setInputError("Please Enter a valid username");
        setInput(e.target.value);
        return false;
      }
    } else if (item?.key === "instagram") {
      const instagramUsernameRegex =
        /^[a-zA-Z0-9][a-zA-Z0-9._]{0,28}[a-zA-Z0-9]$/;
      if (instagramUsernameRegex.test(e.target.value)) {
        setInputError(null);
        setInput(e.target.value);
        return true;
      } else {
        setInputError("Please Enter a valid username");
        setInput(e.target.value);
        return false;
      }
    } else if (item?.key === "twitter") {
      const twitterUsernameRegex = /^[a-zA-Z0-9_]{1,15}$/;
      if (twitterUsernameRegex.test(e.target.value)) {
        setInputError(null);
        setInput(e.target.value);
        return true;
      } else {
        setInputError("Please Enter a valid username");
        setInput(e.target.value);
        return false;
      }
    } else if (item?.key === "fbmassenger") {
      const regex = /^[a-zA-Z0-9_]+$/;
      if (regex.test(e.target.value)) {
        setInputError(null);
        setInput(e.target.value);
        return true;
      } else {
        setInputError("Please Enter a valid username");
        setInput(e.target.value);
        return false;
      }
    } else if (item?.key === "snapchat") {
      const snapchatUsernameRegex = /^[a-zA-Z0-9_]{3,15}$/;
      if (snapchatUsernameRegex.test(e.target.value)) {
        setInputError(null);
        setInput(e.target.value);
        return true;
      } else {
        setInputError("Please Enter a valid username");
        setInput(e.target.value);
        return false;
      }
    } else if (item?.key === "youtube") {
      const youtubeUsernameRegex = /^[a-zA-Z0-9_\-]{1,100}$/;
      const youtubeChannelUrlRegex =
        /^https?:\/\/(www\.)?youtube\.com\/channel\/[A-Za-z0-9_-]+$/;

      if (
        youtubeUsernameRegex.test(e.target.value) ||
        youtubeChannelUrlRegex.test(e.target.value)
      ) {
        setInputError(null);
        setInput(e.target.value);
        return true;
      } else {
        setInputError("Please enter a valid username or YouTube channel URL");
        setInput(e.target.value);
        return false;
      }
    } else if (item?.key === "tikTok") {
      const tiktokUsernameRegex = /^[a-zA-Z0-9_.]{2,24}$/;
      const tiktokUrlRegex =
        /^https?:\/\/(www\.)?tiktok\.com\/@([a-zA-Z0-9_.]{2,24})$/;

      if (
        tiktokUsernameRegex.test(e.target.value) ||
        tiktokUrlRegex.test(e.target.value)
      ) {
        setInputError(null);
        setInput(e.target.value);
        return true;
      } else {
        setInputError("Please enter a valid TikTok username or URL");
        setInput(e.target.value);
        return false;
      }
    } else if (item?.key === "linkedin") {
      const linkedinUsernameRegex = /^[a-zA-Z0-9_-]{1,30}$/;
      const linkedinUrlRegex =
        /^https?:\/\/(www\.)?linkedin\.com\/(in|company)\/[a-zA-Z0-9_-]+(\/[a-zA-Z0-9_-]+)?\/?$/;

      if (
        linkedinUsernameRegex.test(e.target.value) ||
        linkedinUrlRegex.test(e.target.value)
      ) {
        setInputError(null);
        setInput(e.target.value);
        return true;
      } else {
        setInputError("Please enter a valid LinkedIn username or URL");
        setInput(e.target.value);
        return false;
      }
    } else if (item?.key === "spotify") {
      const spotifyUsernameRegex = /^[a-zA-Z0-9_-]{1,30}$/;
      const spotifyUrlRegex =
        /^https?:\/\/open\.spotify\.com\/user\/[a-zA-Z0-9_-]+(\?[^#\s]*)?$/;

      if (
        spotifyUsernameRegex.test(e.target.value) ||
        spotifyUrlRegex.test(e.target.value)
      ) {
        setInputError(null);
        setInput(e.target.value);
        return true;
      } else {
        setInputError("Please enter a valid Spotify username or URL");
        setInput(e.target.value);
        return false;
      }
    } else if (item?.key === "pinterest") {
      const pinterestUsernameRegex = /^[a-zA-Z0-9_]{3,30}$/;
      if (pinterestUsernameRegex.test(e.target.value)) {
        setInputError(null);
        setInput(e.target.value);
        return true;
      } else {
        setInputError("Please Enter a valid username");
        setInput(e.target.value);
        return false;
      }
    } else if (item?.key === "soundcloud") {
      const soundcloudUsernameRegex =
        /^[a-z0-9](?:[a-z0-9]|-(?=[a-z0-9])){1,28}[a-z0-9]$/;
      if (soundcloudUsernameRegex.test(e.target.value)) {
        setInputError(null);
        setInput(e.target.value);
        return true;
      } else {
        setInputError("Please Enter a valid username");
        setInput(e.target.value);
        return false;
      }
    } else if (item?.key === "twitch") {
      const twitchUsernameRegex = /^[a-zA-Z0-9_-]{1,45}$/;
      if (twitchUsernameRegex.test(e.target.value)) {
        setInputError(null);
        setInput(e.target.value);
        return true;
      } else {
        setInputError("Please Enter a valid username");
        setInput(e.target.value);
        return false;
      }
    } else {
      setInputError(null);
      setInput(e.target.value);
    }
  };
  useEffect(() => {
    setInputData(input, item?.title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [input]);

  return (
    <div>
      <div
        className={`rounded-[10px] ${
          darkMode ? "" : "shadow-box_shadow_1"
        } bg-white dark:bg-dark-secondary p-3 md:p-[13px] py-2 md:py-2 flex items-center gap-2`}
      >
        <div className="flex items-center ">
          <ThreeDot />
        </div>
        <div className="p-[3px] md:p-[5px]">
          <div
            style={{
              boxShadow: `-2px 3px 7px ${item?.boxShadow}`,
            }}
            className={`p-[7px] h-[36px] w-[36px] rounded-lg ${item?.iconBg}`}
          >
            {item?.icon && (
              <item.icon className={`${item?.classes} h-full w-full`} />
            )}
          </div>
        </div>
        <div className="w-full flex justify-between items-center gap-2">
          <input
            value={input}
            onChange={(event) => changeHandler(event)}
            type="text"
            id="default-input"
            placeholder={
              item?.placeholderText ? item?.placeholderText : inputPlacholder
            }
            className={`bg-transparent border-0 text-small1_bold dark:text-color_v2_dark placeholder:text-small1 focus:ring-0 focus:border-0 block w-full focus-visible:border-0 focus:outline-none dark:caret-white ${
              inputError ? "text-state_color_error" : "text-body_copy1_color"
            }`}
          />

          <div
            className={`text-xl cursor-pointer ${
              input ? "text-state_color_error" : "text-light_bg_v1"
            }`}
            onClick={() => {
              removeSelectedSocials(item);
              setInputError(null);
            }}
          >
            <RiCloseCircleFill />
          </div>
        </div>
      </div>
      <small className="text-state_color_error leading-none text-xs">
        {inputError}
      </small>
    </div>
  );
};

const Socials = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const { allLangs, tComponent, handleLanguageChange } = useLocales();
  const baseUrl = process.env.REACT_APP_API_URL;
  const { setActiveMainPageNav } = useStateContext();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { themeDirection } = useSettings();
  const { optionId } = useParams();
  const [selectedSocials, setSelectedSocials] = useState([]);
  const [socialSubLoader, setSocialSubLoader] = useState(false);
  const socialLinks = [
    {
      id: 0,
      icon: EmailIcon,
      selectedIcon: EmailIcon,
      boxShadow: "#832BC144",
      iconBg: "bg-gradient-to-tl from-[#832BC1] to-[#F452FF]",
      classes: "",
      title: "Email",
      placeholderText: "name@domain.com",
      key: "email",
    },
    {
      id: 1,
      icon: CallIcon,
      selectedIcon: CallIcon,
      boxShadow: "#D7155B44",
      iconBg: "bg-gradient-to-tl from-[#D7155B] to-[#FF5190]",
      title: "Phone Number",
      placeholderText: "Enter Phone",
      key: "phone",
    },
    {
      id: 2,
      icon: FaceBookIcon,
      selectedIcon: FaceBookIcon,
      boxShadow: "#0062E044",
      iconBg: "bg-gradient-to-t from-[#0062E0] to-[#19AFFF]",
      title: "FaceBook",
      placeholderText: "Username",
      classes: "",
      key: "facebook",
    },
    {
      id: 3,
      icon: InstaIcon,
      selectedIcon: InstaIcon,
      boxShadow: "#643DCE44",
      iconBg:
        "bg-gradient-to-br from-[#FCA759] from-3% via-[#E82D56] via-30% to-[#643DCE] to-18%",
      title: "Instagram",
      placeholderText: "Username",
      key: "instagram",
    },
    {
      id: 4,
      icon: Twitter,
      selectedIcon: Twitter,
      boxShadow: "#0CA8F644",
      iconBg: "bg-gradient-to-b from-[#0CA8F6] to-[#0096E1]",
      classes: "",
      title: "Twitter",
      placeholderText: "Username",
      key: "twitter",
    },
    {
      id: 5,
      icon: Messenger,
      selectedIcon: MessengerWhite,
      boxShadow: "#0099FF44",
      iconBg:
        "bg-gradient-to-bl from-[#FF7061] from-5% via-[#FF5280] via-10% to-[#0099FF] to-90%",
      title: "Messenger",
      placeholderText: "Username",
      key: "fbmassenger",
    },
    {
      id: 6,
      icon: SnapIcon,
      selectedIcon: SnapIcon,
      boxShadow: "#DAAD0C44",
      iconBg: "bg-gradient-to-tl from-[#DAAD0C] to-[#FFED00]",
      title: "SnapChat",
      placeholderText: "Username",
      key: "snapchat",
    },
    {
      id: 7,
      icon: YoutubeIcon,
      selectedIcon: YoutubeIconWhite,
      boxShadow: "#DB050544",
      iconBg: "bg-gradient-to-br from-[#DB0505] to-[#FF0000]",
      title: "YouTube",
      classes: "",
      placeholderText: "Username or Full URL",
      key: "youtube",
    },
    {
      id: 8,
      icon: TikTok,
      selectedIcon: TikTokWhite,
      boxShadow: "#00000033",
      iconBg: "bg-gradient-to-tl from-[#323232] to-[#000000]",
      title: "Tik Tok",
      classes: "",
      placeholderText: "Username or Full URL",
      key: "tikTok",
    },
    {
      id: 9,
      icon: LinkedIn,
      selectedIcon: LinkedIn,
      boxShadow: "#00669933",
      iconBg: "bg-gradient-to-tl from-[#006699] to-[#058CCF]",
      title: "LinkedIn",
      placeholderText: "Username or Full URL",
      key: "linkedin",
    },
    {
      id: 10,
      icon: Spotify,
      selectedIcon: Spotify,
      boxShadow: "#00D95F33",
      iconBg: "bg-gradient-to-tl from-[#00D95F] to-[#10BC4C]",
      title: "Spotify",
      placeholderText: "Username or Full URL",
      key: "spotify",
    },
    {
      id: 11,
      icon: Pinterest,
      selectedIcon: Pinterest,
      boxShadow: "#CC060633",
      iconBg: "bg-gradient-to-tl from-[#CC0606] to-[#FF0000]",
      title: "Pinterest",
      classes: "",
      placeholderText: "Username",
      key: "pinterest",
    },
    {
      id: 12,
      icon: SoundCloud,
      selectedIcon: SoundCloud,
      boxShadow: "#FF433A33",
      iconBg: "bg-gradient-to-tl from-[#FF433A] to-[#FF9436]",
      title: "SoundCloud",
      classes: "",
      placeholderText: "Username",
      key: "soundcloud",
    },
    {
      id: 13,
      icon: Twitch,
      selectedIcon: Twitch,
      boxShadow: "#732ADF44",
      iconBg: "bg-gradient-to-tl from-[#732ADF] to-[#9146FF]",
      title: "Twitch",
      placeholderText: "Username",
      key: "twitch",
    },
  ];

  const [prevData, setPrevData] = useState(null);
  const userID = JSON.parse(localStorage.getItem("user")).userid;
  const url = optionId
    ? baseUrl + "/api/user/getOption/" + userID + "/" + optionId
    : null;

  const { data, loading, error } = useFetchBlock(url);

  const [selectReporterTypeDropDown, setSelectReporterTypeDropDown] =
    useState(false);
  const [selectedReporterType, setSelectedReporterType] = useState("English");
  const [selectedLang, setSelectedLang] = useState("en");

  useEffect(() => {
    if (selectedLang) {
      handleLanguageChange(selectedLang);
    }
  }, [selectedLang]);

  useEffect(() => {
    setPrevData({
      ...data?.data,
      coloum_value:
        data?.data?.coloum_value && JSON.parse(data?.data?.coloum_value),
    });
  }, [data, error]);

  useEffect(() => {
    const keys = prevData?.coloum_value && Object.keys(prevData?.coloum_value);
    const setSelectedPrevSocialsFun = (key, val) => {
      const socialExists = selectedSocials.some((item) => item.title === key);
      const prevSelected = socialLinks.filter((link) => link.key === key);
      const updatedSocials = prevSelected.map((social) => {
        if (social.key === key) {
          return { ...social, value: val };
        }
        return social;
      });
      if (!socialExists) {
        setSelectedSocials((prev) => [...prev, ...updatedSocials]);
      }
      return;
    };
    keys?.map((key) => {
      setSelectedPrevSocialsFun(key, prevData?.coloum_value?.[key]);
      return { key: key, value: prevData?.coloum_value?.[key] };
    });
    if (prevData?.language) {
      setSelectedLang(prevData?.language);
      const matchedLang = allLangs?.find(
        (lang) => lang.value === prevData?.language
      );
      const shouldSetLang = matchedLang?.label;
      setSelectedReporterType(shouldSetLang);
      handleLanguageChange(prevData?.language);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prevData]);

  useEffect(() => {
    setActiveMainPageNav(true);

    return () => {
      setActiveMainPageNav(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setSelectedSocialsFun = (social) => {
    const socialExists = selectedSocials.some(
      (item) => item.title === social.title
    );

    if (!socialExists) {
      setSelectedSocials((prev) => [...prev, social]);
    }
  };

  const removeSelectedSocials = (social) => {
    setSelectedSocials((prev) => {
      const newArray = prev.filter((item) => {
        return item.id !== social.id;
      });
      return newArray;
    });
  };

  const setInputData = (val, title) => {
    setSelectedSocials((prev) => {
      const updatedSocials = prev.map((social) => {
        if (social.title === title) {
          return { ...social, value: val };
        }
        return social;
      });

      return updatedSocials;
    });
    return true;
  };

  const submitHandler = async () => {
    if (!optionId) {
      if (!selectedSocials?.length) {
        toast.error("Please select Socials");
      } else {
        const data = {};

        selectedSocials?.map((item, i) => {
          if (item.value !== "" && item.value) {
            switch (item?.title) {
              case "Email":
                return (data.emailState = item.value);
              case "Phone Number":
                return (data.phoneState = item.value);
              case "FaceBook":
                return (data.facebookState = item.value);
              case "Messenger":
                return (data.massengerState = item.value);
              case "Instagram":
                return (data.instagramState = item.value);
              case "Twitter":
                return (data.twitterState = item.value);
              case "Tik Tok":
                return (data.tiktokState = item.value);
              case "YouTube":
                return (data.youtubeState = item.value);
              case "SoundCloud":
                return (data.soundcloudState = item.value);
              case "LinkedIn":
                return (data.linkedinState = item.value);
              case "Spotify":
                return (data.spotifyState = item.value);
              case "Pinterest":
                return (data.pinterestState = item.value);
              case "SnapChat":
                return (data.snapchatState = item.value);
              case "Twitch":
                return (data.twitchState = item.value);

              default:
                break;
            }
          }
          return null;
        });
        // let result = [data];
        const keys = Object.keys(data);

        if (keys.length === 0) {
          toast.error("All fields required ");
          return;
        } else {
          setSocialSubLoader(true);
          // data.columnName = "social";
          data.columnName = "social";
          data.language = selectedLang;
          await dispatch(creatingSocialBlock(data)).then(() => {
            fetchingLinksList();
          });
        }
        setSocialSubLoader(false);
      }
    } else {
      if (!selectedSocials?.length) {
        toast.error("Please select Socials");
      } else {
        const data = {};
        selectedSocials?.map((item, i) => {
          if (item.value !== "" && item.value) {
            switch (item?.title) {
              case "Email":
                return (data.emailState = item.value);
              case "Phone Number":
                return (data.phoneState = item.value);
              case "FaceBook":
                return (data.facebookState = item.value);
              case "Messenger":
                return (data.massengerState = item.value);
              case "Instagram":
                return (data.instagramState = item.value);
              case "Twitter":
                return (data.twitterState = item.value);
              case "Tik Tok":
                return (data.tiktokState = item.value);
              case "YouTube":
                return (data.youtubeState = item.value);
              case "SoundCloud":
                return (data.soundcloudState = item.value);
              case "LinkedIn":
                return (data.linkedinState = item.value);
              case "Spotify":
                return (data.spotifyState = item.value);
              case "Pinterest":
                return (data.pinterestState = item.value);
              case "SnapChat":
                return (data.snapchatState = item.value);
              case "Twitch":
                return (data.twitchState = item.value);

              default:
                break;
            }
          }
          return null;
        });
        var result = [data];

        if (result?.length <= 0) {
          toast.error("Plase Enter social URLs");
          return;
        }
        setSocialSubLoader(true);
        data.columnName = "social";
        data.optionid = optionId;
        data.language = selectedLang;

        await dispatch(updatingSocialCard(data)).then(() => {
          fetchingLinksList();
        });
        setSocialSubLoader(false);
      }
    }
  };

  const fetchingLinksList = () => {
    //  _______data needed for linklist api
    const user = JSON.parse(localStorage.getItem("user"));

    const userId = user.userid;
    const usertoken = user.token;
    const linkId = localStorage.getItem("linkId");
    const linkListData = {
      userId,
      usertoken,
      linkId,
    };

    dispatch(gettingLinkList(linkListData));
  };

  // handling social block add api reponses messages
  const { isSocialBlockError, isSocialBlockLoading, isSocialBlockSuccess } =
    useSelector((state) => state?.socialBlock);
  const { status, message } = useSelector(
    (state) => state?.socialBlock?.socialBlock
  );

  useEffect(() => {
    if (status === "success" && isSocialBlockSuccess) {
      toast.success(message);
      navigate("/dashboard");
    } else {
      if (isSocialBlockError) {
        toast.error(message);
      }
    }
    dispatch(resetUser());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isSocialBlockError,
    isSocialBlockSuccess,
    dispatch,
    isSocialBlockLoading,
  ]);

  // handling social updates api response messages

  const {
    updatedSocialCard,
    socialCardError,
    socialCardSuccess,
    socialCardLoading,
    socialCardErrorMsg,
  } = useSelector((state) => state?.cards?.socialCard);

  useEffect(() => {
    if (updatedSocialCard?.status === "success" && socialCardSuccess) {
      toast.success(updatedSocialCard?.message);
      fetchingLinksList();
      navigate("/dashboard/component");
    }
    if (updatedSocialCard?.status === "failed" && socialCardSuccess) {
      toast.error(updatedSocialCard?.message);
    }
    if (socialCardError && socialCardErrorMsg) {
      toast.error(socialCardErrorMsg?.message);
    }
    dispatch(resetSocialCard());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedSocialCard, socialCardLoading]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const deleteHandler = async () => {
    const user = JSON.parse(localStorage.getItem("user"));

    const userId = user.userid;
    const obj = {
      optionId: optionId,
      userId: userId,
    };
    await dispatch(deleteBlock(obj)).then(() => {});
  };

  const handleDeleteModal = () => {
    deleteHandler();
    setIsModalOpen(false);
  };

  //  delete block api response state handler
  const {
    DeleteBlock,
    isDeleteBlockError,
    isDeleteBlockSuccess,
    isDeleteBlockLoading,
    isDeleteBlockErrorMsg,
  } = useSelector((state) => state?.deleteBlock);

  useEffect(() => {
    if (DeleteBlock?.data?.status === "success" && isDeleteBlockSuccess) {
      toast.success(DeleteBlock?.data?.message);
      fetchingLinksList();
      navigate("/dashboard/component");
    }
    if (DeleteBlock?.data?.status === "failed" && isDeleteBlockSuccess) {
      toast.error(DeleteBlock?.data?.message);
    }
    if (isDeleteBlockError) {
      toast.error(isDeleteBlockErrorMsg);
    }
    dispatch(resetDeletBlock());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDeleteBlockLoading, DeleteBlock]);

  const handleChangeLang = (newLang) => {
    handleLanguageChange(newLang);
  };

  return (
    <>
      <ConfirmModal
        isOpen={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onConfirm={handleDeleteModal}
        selectedLang={selectedLang}
      />
      {loading && (
        <div
          style={{ zIndex: "999999" }}
          className="fixed inset-0 h-screen bg-[#ffffffa7] pt-5 flex justify-center items-center overflow-hidden"
        >
          <img src={SpinnerGiff} alt="..." />
        </div>
      )}
      <I18nextProvider i18n={i18nForComponent}>
        <div className="px-6 md:px-0 mt-[37px] md:mt-0 flex items-center justify-between">
          <Link to={"/dashboard/component"}>
            <div className="flex text-body_copy2 items-center cursor-pointer gap-2">
              <div className="text-2xl font-semibold text-heading_color">
                {darkMode ? (
                  <LeftArrowDark
                    className={`${
                      themeDirection === "rtl" ? "transform -scale-x-100" : ""
                    }`}
                  />
                ) : (
                  <LeftArrow
                    className={`${
                      themeDirection === "rtl" ? "transform -scale-x-100" : ""
                    }`}
                  />
                )}
              </div>
              <p className="pt-1 dark:text-color_v1_dark">
                {tComponent("socials.socials")}
              </p>
            </div>
          </Link>
          {!optionId && (
            <div className="flex items-center justify-center">
              <div className="relative w-[115px] sm:w-[145px]">
                <div
                  onClick={() => {
                    setSelectReporterTypeDropDown(!selectReporterTypeDropDown);
                  }}
                  className={`bg-light_bg_v5 capitalize p-[13px] text-small2 lg:text-body_copy2 rounded-md w-full flex justify-between items-center cursor-pointer`}
                >
                  {selectedReporterType
                    ? selectedReporterType
                    : tComponent("socials.select_lang")}
                  <DownArrow />
                </div>
                {selectReporterTypeDropDown && (
                  <div className="absolute top-14 mb-20 left-0 w-full z-50 p-[7px] px-[10px] md:p-[15px] bg-light_bg_v5  rounded-lg border flex flex-col max-h-40 overflow-y-auto">
                    {allLangs?.map((item, i) => {
                      return (
                        <div
                          key={i}
                          onClick={() => {
                            setSelectedLang(item.value); // Set selected language code
                            setSelectedReporterType(item?.label);
                            setSelectReporterTypeDropDown(false);
                            handleChangeLang(item?.value);
                          }}
                          className="px-[10px] md:px-[15px] py-[7px] md:py-[10px] capitalize text-small2 lg:text-body_copy2 text-heading_color cursor-pointer hover:bg-light_bg_v4 rounded-md"
                        >
                          {item.label}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          )}
          {optionId && (
            <div
              className={`w-[100px] bg-light_bg_v5 capitalize p-[10px] text-small2 lg:text-body_copy2 rounded-md flex justify-center items-center`}
            >
              {selectedReporterType ? selectedReporterType : "English"}
            </div>
          )}
        </div>
        <div
          className="sm:hidden px-6 md:px-0 mt-10 grid grid-cols-1 gap-3"
          style={{
            direction: selectedLang === "ar" ? "rtl" : "ltr",
          }}
        >
          {selectedSocials?.map((item, i) => {
            return (
              <LEditRExpandIconCard
                key={i}
                item={item}
                removeSelectedSocials={removeSelectedSocials}
                icon={item?.icon}
                boxShadow={item?.boxShadow}
                iconBg={item?.iconBg}
                classes={item?.classes}
                title={item?.title}
                inputPlacholder={`Enter ${item.title}`}
                setInputData={setInputData}
              />
            );
          })}
        </div>
        <div
          style={{
            direction: selectedLang === "ar" ? "rtl" : "ltr",
          }}
          className={`px-6 md:px-0  ${
            selectedSocials?.length > 0 ? "mt-[50px]" : "mt-0 mb-[50px] sm:mb-0"
          } sm:mt-7 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-1 xl:grid-cols-3 gap-[15px] `}
        >
          {socialLinks.map((item, i) => {
            const socialExists = selectedSocials.some(
              (social) => social.title === item.title
            );
            return (
              <div onClick={() => setSelectedSocialsFun(item)} key={i}>
                <MainCard
                  icon={socialExists ? item?.selectedIcon : item?.icon}
                  boxShadow={socialExists ? "" : item?.boxShadow}
                  iconBg={socialExists ? "bg-light_bg_v1" : item?.iconBg}
                  classes={item?.classes}
                  title={item?.title}
                  titleClasses={socialExists ? "text-light_bg_v1" : ""}
                />
              </div>
            );
          })}
        </div>
        <div
          className="pt-8 px-6 md:px-0  mt-3 hidden sm:grid grid-cols-1 gap-4"
          style={{
            direction: selectedLang === "ar" ? "rtl" : "ltr",
          }}
        >
          {selectedSocials?.map((item, i) => {
            return (
              <LEditRExpandIconCard
                key={i}
                item={item}
                removeSelectedSocials={removeSelectedSocials}
                icon={item?.icon}
                boxShadow={item?.boxShadow}
                iconBg={item?.iconBg}
                classes={item?.classes}
                title={item?.title}
                inputPlacholder={`${tComponent("socials.enter")} ${item.title}`}
                setInputData={setInputData}
              />
            );
          })}
        </div>

        {selectedSocials?.length > 0 && (
          <div
            className="flex px-6 md:px-0  my-[25px] items-center justify-end"
            style={{
              direction: selectedLang === "ar" ? "rtl" : "ltr",
            }}
          >
            <button
              onClick={() => (optionId ? setIsModalOpen(true) : null)}
              className="flex justify-center items-center"
            >
              {darkMode ? <TrashIconDark /> : <TrashIcon />}
              <p className="ps-1.5 pt-1 text-small3_b gray-700 text-heading_color dark:text-color_v1_dark">
                {tComponent("socials.delete_cap")}
              </p>
            </button>

            <ExtraSmallFilledButton
              name={`${tComponent("socials.save_cap")}`}
              buttonType={"submit"}
              isLoading={socialSubLoader}
              onClickHandler={submitHandler}
              classes={"ms-3"}
            />
          </div>
        )}
      </I18nextProvider>
    </>
  );
};

export default Socials;
/* eslint-disable no-useless-escape */
